module.exports = __webpack_public_path__ + "static/media/arrow-back-inex.fe6acb0a.svg";